/** @jsxImportSource @emotion/react */

import { Alignment, Button, Displaying, FontSize, Spacing, Typography } from "@bonusx-global/bx-design-system";
import { BellExclamationDuotone } from "@bonusx-global/bx-icons";
import styled from "@emotion/styled";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { useModal } from "../../hooks/useDialog";
import { useHeaderCloseButton } from "../../hooks/useHeaderCloseButton";
import Emoji from "../common/Emoji";

const BigBellExclamationDuotone = styled(BellExclamationDuotone)({
  fontSize: FontSize["3xl"],
});

const GridContainer = styled(Grid)({
  textAlign: Alignment.center,
  gap: Spacing["1500"],
});

const GridActionsContainer = styled(Grid)({
  gap: Spacing["750"],
});

export interface ConfirmExitFromQuestionnaireProps {
  closeButtonURL?: string;
}

function ConfirmExitFromQuestionnaire({ closeButtonURL }: Readonly<ConfirmExitFromQuestionnaireProps>) {
  const closeButton = useHeaderCloseButton();
  const { close: closeModal } = useModal();
  const navigate = useNavigate();

  function onClickBackToQuestionnaire() {
    let closeUrl = closeButtonURL;

    if (typeof closeButton?.url === "string") closeUrl = closeButton.url;

    if (typeof closeUrl === "string") {
      navigate(closeUrl, { replace: true });
    } else {
      navigate(-1);
    }

    closeModal();
  }

  return (
    <GridContainer container justifyContent={Alignment.center}>
      <BigBellExclamationDuotone />

      <Grid item xs={12}>
        <Typography variant="h5">Vuoi davvero uscire?</Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1" color="textSecondary">
          Abbiamo salvato le tue risposte, potrai riprendere in qualsiasi momento da dove hai lasciato. Torna però{" "}
          <Emoji ariaLabel="" emojiSymbol="🥹​" />
        </Typography>
      </Grid>

      <GridActionsContainer item xs={12} display={Displaying.flex} justifyContent={Alignment.flexEnd}>
        <Button variant="outlined" color="primary" onClick={onClickBackToQuestionnaire}>
          Esci
        </Button>
        <Button variant="contained" color="primary" onClick={closeModal}>
          Continua
        </Button>
      </GridActionsContainer>
    </GridContainer>
  );
}

export default ConfirmExitFromQuestionnaire;
